// @ts-nocheck
import React from 'react';

export default function PasteFab({ onPaste }: { onPaste: (url: string) => void }) {
  const handleClick = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const url = (text || '').trim();
      if (!/^https?:\/\//i.test(url)) return;
      onPaste(url);
    } catch {}
  };
  return (
    <button
      className="fixed bottom-20 right-4 sm:hidden inline-flex items-center gap-2 bg-blue-600 text-white px-4 py-3 rounded-full shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
      onClick={handleClick}
      aria-label="Pegar enlace"
      title="Pegar enlace"
    >
      <span>📋</span>
      <span>Pegar enlace</span>
    </button>
  );
}
